<template>
    <el-dialog :title="config_.title"
               :visible.sync="openDialog"
               :before-close="closeDialog"
               :close-on-click-modal="false"
               top="4%"
               width="1024px"
               append-to-body
               class="multi-select-dialog">
        <div class="dialog-body" v-loading="loading">
            <div :class="['data-show', !config.showCheckedList&&'full-box']">
                <el-row class="data-list">
                    <el-col :span="24">
                        <div class="grid-content bg-purple-dark">
                            <el-table
                                :row-key="getRowKeys"
                                border
                                ref="myTable"
                                :data="tableData"
                                tooltip-effect="dark"
                                style="width: 100%"
                                height="390"
                                @select-all="changeSelectAll"
                                @select="changSelect">
                                <el-table-column
                                    type="selection"
                                    width="55">
                                </el-table-column>
                                <el-table-column v-for="(item, index) in config_.table" :key="index"
                                    :prop="item.prop"
                                    :label="item.label"
                                    show-overflow-tooltip>
                                </el-table-column>
                            </el-table>
                            <mPage v-if="false" :total="total"
                                   :currentPage="currentPage"
                                   :pageData="pageData"
                                   @on-size-change="handleSizeChange"
                                   @on-page-change="handleCurrentChange">
                            </mPage>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div v-if="config.showCheckedList" class="checked-list">
                <div class="checked-list-title">
                    <span class="checked-num">已选<i>&nbsp;{{checkedList.length}}&nbsp;</i></span>
                    <span class="clear-all" @click="clearAll">清空</span>
                </div>
                <div class="checked-items">
                    <div v-for="(item, index) in checkedList" :key="index">
                        <el-tooltip
                            effect="dark"
                            placement="left">
                            <div slot="content">{{item[config_.tooltip[0]]}}<br/>{{item[config_.tooltip[1]]}}</div>
                            <div class="checked-every">
                                <span>{{item[config_.tooltip[1]]}}</span>
                                <span @click="clearOne(item)"><i class="el-icon-close" style="font-size: 12px;"></i></span>
                            </div>
                        </el-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button :loading="btnLoading" @click="closeDialog">取 消</el-button>
            <el-button :loading="btnLoading" type="primary" @click="confirmRolesDialog">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>

import mPage from '@/components/awesome/page/mPanel3/mPage/Main';
import { mapGetters } from 'vuex';

export default {
    name: 'platform-dialog',
    components: { mPage },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            }
        },
        advanceCheckedList: {
            type: Array,
            default() {
                return [];
            }
        },
        config: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        ...mapGetters(['currentTenant'])

    },
    data() {
        return {
            config_: this.config,
            openDialog: true,
            inputValue: '',
            requestMethod: 'get',
            tableData: [],
            checkedList: [],
            currentPage: 1,
            total: 0,
            pageData: {
                pageSize: 10,
                pageSizes: [10, 20, 30, 50, 100],
                layout: 'total, sizes, prev, pager, next, jumper'
            },
            openFlag: 1,
            loading: true,
            btnLoading: false
        };
    },
    methods: {
        show(flag, data) {
            this.openDialog = flag;
            data && (this.tableData = data);
        },
        pageInit() {
            this.currentPage = 1;
            this.pageData.pageSize = 10;
        },
        getRowKeys(row) {
            return row.id;
        },
        closeDialog() {
            this.openFlag = 1;
            this.inputValue = '';
            this.checkedList = [];
            this.$emit('closeDialog', false);
        },
        confirmRolesDialog() {
            this.inputValue = '';
            this.$emit('confirmDialog', { open: false, onLoading: () => (this.btnLoading = true), offLoading: () => (this.btnLoading = false), checkList: [...this.checkedList] });
            // this.checkedList = [];
        },
        clearAll() {
            this.checkedList = [];
            this.$refs.myTable.clearSelection();
        },
        clearOne(item) {
            const num = this.checkedList.indexOf(item);
            this.checkedList.splice(num, 1);
            this.$refs.myTable.toggleRowSelection(item, false);
            this.tableData.forEach(e => {
                if (e[this.config_.rowKeyProp || 'id'] === item[this.config_.rowKeyProp || 'id']) {
                    this.$refs.myTable.toggleRowSelection(e, false);
                }
            });
        },
        /** 点每一行 **/
        changSelect(data, row) {
            let j = false;
            let index = 0;
            this.checkedList.forEach(e => {
                if (e[this.config_.rowKeyProp || 'id'] === row[this.config_.rowKeyProp || 'id']) {
                    j = true;
                    index = this.checkedList.indexOf(e);
                }
            });
            if (this.openFlag !== 1) {
                if (data.indexOf(row) === -1 && j) {
                    this.checkedList.splice(index, 1);
                } else if (data.indexOf(row) !== -1 && !j) {
                    this.checkedList.push(row);
                }
            }
        },
        /** 全选 **/
        changeSelectAll(data) {
            if (this.openFlag !== 1) {
                if (data.length === 0) {
                    this.tableData.forEach(e => {
                        this.checkedList.forEach(el => {
                            if (e[this.config_.rowKeyProp || 'id'] === el[this.config_.rowKeyProp || 'id']) {
                                const i = this.checkedList.indexOf(el);
                                this.checkedList.splice(i, 1);
                            }
                        });
                    });
                } else {
                    this.tableData.forEach(e => {
                        if (this.checkedList.indexOf(e) === -1) {
                            this.checkedList.push(e);
                        }
                    });
                }
            }
        },
        clickToSearch() {
            this.pageInit();
            this.handleSearch();
        },
        handleSizeChange(data) {
            this.pageData.pageSize = data;
            this.openFlag = 1;
            this.handleSearch();
        },
        handleCurrentChange(data) {
            this.currentPage = data;
            this.openFlag = 1;
            this.handleSearch();
        },
        checkItems() {
            if (this.$refs.myTable) {
                this.checkedList.forEach((e) => {
                    this.tableData.forEach((el) => {
                        if (e[this.config_.rowKeyProp || 'id'] === el[this.config_.rowKeyProp || 'id']) {
                            this.$refs.myTable.toggleRowSelection(el, true);
                        }
                    });
                });
            }
        },
        async  handleGetData(flag) {
            switch (this.advanceCheckedList.length) {
            case 0:
                this.openFlag = 0;
                if (this.checkedList.length > 0) {
                    this.$nextTick(() => {
                        this.checkItems();
                        this.loading = false;
                    });
                } else { this.loading = false; }
                break;
            default:
                switch (flag) {
                case 1:
                    this.checkedList = [...this.advanceCheckedList];
                    this.$nextTick(() => {
                        this.checkItems();
                        this.openFlag = 0;
                        this.loading = false;
                    });
                    break;
                default:
                    this.$nextTick(() => {
                        this.checkItems();
                        this.openFlag = 0;
                        this.loading = false;
                    });
                }
            }
        },
        /** 查询 **/
        handleSearch() {
            this.handleGetData(0);
        }
    },
    watch: {
        tableList: {
            immediate: true,
            deep: true,
            handler(newValue, oldValue) {
                this.tableData = newValue;
            }
        }
    },
    mounted() {
        this.handleGetData(1);
    }
};
</script>
<style lang="less">
    .multi-select-dialog {
        .dialog-body {
            width: 100%;
            height: 500px;
        }
        .el-dialog__body {
            padding: 0;
            border-bottom: 1px solid #E6E6E6;
        }
        .data-show {
            margin-left: 16px;
            padding-top: 16px;
            padding-right: 10px;
            float: left;
            height: 100%;;
            width: 730px;
            border-right: 1px solid #E6E6E6;
            /*background-color: blue;*/
            box-sizing: border-box;
        }
        .full-box{
            border-right: none;
            width: calc(100% - 16px);
        }
        .checked-list {
            margin: 0 16px 16px 10px;
            padding-top: 53px;
            height: 100%;
            width: calc(100% - 772px);
            float: left;
            box-sizing: border-box;
        }
        .select-frame .el-input{
            width: 120px;
        }
        .check-frame.el-input{
            width: 250px;
        }
        .search-button.el-button {
            margin-left: 10px;
        }
        .data-list {
            height: calc(100% - 94px);
            margin-top: 10px;
        }
        .checked-list-title {
            width: 100%;
            height: 38px;
            background-color: #F2F2F2;
            line-height: 38px;
            color: #666666;
            padding: 0 10px 0 20px;
            box-sizing: border-box;
        }
        .checked-num i {
            font-style: normal;
            color: #3EA4EB;
        }
        .clear-all {
            float: right;
            cursor: pointer;
        }
        .checked-every {
            width: 100%;
            height: 38px;
            line-height: 38px;
            color: #666666;
            padding: 0 10px 0 20px;
            box-sizing: border-box;
        }
        .checked-every:hover {
            background-color: #F0F8FA;
        }
        .checked-every span:last-child{
            float: right;
            cursor: pointer;
            color: #AAAAAA;
            font-size: 18px;
        }
        .checked-items {
            width: 100%;
            height: 409px;
            overflow: auto;
        }
        .el-tooltip__popper {
            height: 159px;
            width: 66px;
        }
        .el-pagination {
            float: right;
            margin-top: 14px
        }
    }
</style>
